import { render } from "./support_details.vue?vue&type=template&id=1d9140c4"
import script from "./support_details.vue?vue&type=script&lang=js"
export * from "./support_details.vue?vue&type=script&lang=js"

import "./support_details.vue?vue&type=style&index=0&id=1d9140c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__